/**
 * A function that returns a map of input devices
 * @return A Promise containing a string of device labels
 */

export default async function (): Promise<Map<string, { label: string, kind: string }>> {

  const devices: { deviceId: string, kind: string, label: string }[] = await navigator.mediaDevices.enumerateDevices()

  return devices
    .filter(device => device.kind.match(/input/))
    .reduce((deviceMap, device) =>
      deviceMap.set(device.deviceId, {
        label: device.label,
        kind: device.kind.replace('input', '')
      }), new Map())

}
